// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import ChevronDown from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import ChevronsUpDown from "@store/Library/Components/Toolkit/Icons/ChevronsUpDown";
import ChevronUp from "@store/Library/Components/Toolkit/Icons/ChevronUp";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
const borderWidth = "1px";
const borderRadius = "10px";
/* Store Custom Code - End */

const baseCellStyles = () => css`
    height: auto;
    /* Store Removed - border */
    text-align: left;
    line-height: ${x => x.theme.design.typography.lineHeight.small};
`;

const dataTable: Styleguide["dataTable"] = {
    defaultProps: {
        headerTypographyProps: {
            weight: "inherit",
            size: "inherit",
        },
        cellTypographyProps: {
            size: "inherit",
        },
        sortClickableProps: {
            css: css`
                ${focusStyles()}
                width: 100%;
                height: 100%;
                justify-content: space-between;
                color: inherit;

                &:hover {
                    text-decoration: underline;
                }
            `,
        },
        sortIconProps: {
            size: 16,
            css: css`
                color: inherit;
                margin-left: 0.5em;
            `,
        },
        // Store Removed - sortIconSources
        /* Store Custom Code - Start */
        css: css`
            border-radius: ${borderRadius};
            border-color: ${getColor("common.borderLight")};
            border-width: ${borderWidth};
            border-collapse: separate;
            border-spacing: 0;

            thead,
            tbody {
                &:first-child > tr:first-child {
                    > td,
                    > th {
                        border-top-style: solid;
                        padding: 12px 16px;

                        &:first-child {
                            border-top-left-radius: ${borderRadius};
                        }

                        &:last-child {
                            border-top-right-radius: ${borderRadius};
                        }
                    }
                }

                &:last-child > tr:last-child {
                    > td,
                    > th {
                        &:first-child {
                            border-bottom-left-radius: ${borderRadius};
                        }

                        &:last-child {
                            border-bottom-right-radius: ${borderRadius};
                        }
                    }
                }
            }

            th,
            td {
                border-bottom-style: solid;
                border-width: ${borderWidth};
                border-color: ${getColor("common.borderLight")};

                &:first-child {
                    border-left-style: solid;
                }

                &:last-child {
                    border-right-style: solid;
                }
            }
        `,
        /* Store Custom Code - End */
        cssOverrides: {
            header: css`
                ${baseCellStyles()}
                padding: ${pxToRem(16) /* Store Custom Code */};
                background-color: ${getColor("common.accent") /* Store Custom Code */};
                color: ${getColor("text.accent") /* Store Custom Code */};
                font-weight: ${x => x.theme.design.typography.weight.semibold /* Store Custom Code */};
                /* Store Custom Code - Start */
                font-size: ${x => x.theme.design.typography.size.smaller};
                /* Store Custom Code - End */
            `,
            cell: css`
                ${baseCellStyles()}
                padding: ${pxToRem(16) /* Store Custom Code */};
                font-size: ${x => x.theme.design.typography.size.smaller};
                font-weight: inherit;
            `,
            /* Store Custom Code - Start */
            evenRow: css`
                background-color: ${getColor("common.background")};
            `,
            /* Store Custom Code - End */
        },
    },
};

export default dataTable;
